<app-modal
  [isOpen]="isOpen()"
  [title]="title()"
  (close)="onClose()"
>
  <div class="grid grid-cols-2 gap-4 min-w-100 max-w-[600px]">
    @for (def of filterDefinitions(); track def.key) {
      <div class="flex flex-col" [ngClass]="{ 'col-span-2': def.type === 'checkbox' }">
        @if (def.type === 'text') {
          <app-input-general
            [formControlGeneral]="getFormControl(def.key)"
            [label]="def.label"
            [placeholder]="def.placeholder || ''"
          />
        }
        @if (def.type === 'select') {
          <app-input-general-select
            [formControlGeneral]="getFormControl(def.key)"
            [label]="def.label"
            [placeholder]="'Seleccionar...'"
            [arrayData]="getSelectOptions(def)"
            [inputSelect]="{ value: 'value', description: 'description' }"
          />
        }
        @if (def.type === 'checkbox') {
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium mb-1 text-(--color-text-secondary)">{{ def.label }}</label>
            <app-input-general-checkbox
              [formControlGeneral]="getFormControl(def.key)"
              [label]="def.label"
            />
          </div>
        }
        @if (def.type === 'date') {
          <app-input-general-calendar
            [formControlGeneral]="getFormControl(def.key)"
            [label]="def.label"
            [placeholder]="'DD/MM/YYYY'"
          />
        }
      </div>
    }
  </div>

  <div modal-footer class="flex justify-between items-center pt-4 border-t border-(--color-border) mt-4">
    <app-button
      type="secondary"
      [text]="'common.actions.clean' | translate"
      size="sm"
      (buttonClick)="onClear()"
    />
    <div class="flex gap-2">
      <app-button
        type="ghost"
        [text]="'common.actions.cancel' | translate"
        size="sm"
        (buttonClick)="onCancel()"
      />
      <app-button
        type="primary"
        [text]="'common.actions.apply' | translate"
        size="sm"
        (buttonClick)="onApply()"
      />
    </div>
  </div>
</app-modal>
